/**
 * Overall-score bands for badges across the app.
 *
 * Colors live on CSS tokens (`--score-high-fg` etc.) so they follow the theme.
 * Classes: `.score-badge--high|medium|low|neutral`.
 *
 * - High: score >= 7
 * - Medium: 5 <= score < 7
 * - Low: score < 5
 */

export type ScoreBadgeTier = 'high' | 'medium' | 'low' | 'neutral';

export function getScoreTier(score: number | null | undefined): ScoreBadgeTier {
  if (score === null || score === undefined) return 'neutral';
  const s = Number(score);
  if (!Number.isFinite(s)) return 'neutral';
  if (s >= 7) return 'high';
  if (s < 5) return 'low';
  return 'medium';
}

/** BEM modifier for use with `.score-badge` (e.g. `score-badge--high`). */
export function getScoreBadgeClass(score: number | null | undefined): string {
  return `score-badge--${getScoreTier(score)}`;
}
